import type { Prisma as PrismaTypes } from "encamp-prisma/generated/client";

import { Prisma } from "encamp-prisma/generated/browser";

export const AUDIT_DECIMAL_PRECISION = {
  billedAmount: 2,
  taxAmount: 2,
  wasteFeeAmount: 2,
  fuelFeeAmount: 2,
  environmentalAdjustmentFeeAmount: 2,
  minimumAmount: 2,
  baseAmount: 3,
  expectedBaseAmount: 3,
  variance: 3,
  rateAmount: 6,
} as const satisfies Record<string, number>;

export type AuditMoneyColumn = keyof typeof AUDIT_DECIMAL_PRECISION;

/** Round the expected charge to the stored base amount's precision. */
export function roundExpectedBaseAmount(amount: PrismaTypes.Decimal): PrismaTypes.Decimal {
  return amount.toDecimalPlaces(
    AUDIT_DECIMAL_PRECISION.expectedBaseAmount,
    Prisma.Decimal.ROUND_HALF_UP
  );
}
